import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import useClientRepository from "../../../../../../repository/emergency/useClientRepository";
import {useEffect, useRef} from "react";
import Box from "@mui/material/Box";
import {Button, Link} from "@mui/material";
import {ArrowDownward, Call, PhoneMissed} from "@mui/icons-material";
import isNull from "../../../../../../mixin/isNull";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import parameter from "../../../../../../enum/parameter";

export default function ({qualityInspectionId, clientId}) {
    const eventDispatcher = useEventDispatcher();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const clientRepository = useClientRepository();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(qualityInspectionId).select();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();
    const callClientButtonRef = useRef();
    const callBeneficiaryLink = useRef();
    const smsBeneficiaryLink = useRef();

    useEffect(() => {
        qualityInspectionRepository.findOneById(qualityInspectionId).exec();
        clientRepository.findOneById(clientId).exec();
    }, []);

    useEffect(() => {
        if (isNull(client)) return;

        eventDispatcher.launcher("call-client");
    }, [JSON.stringify(client)]);

    const handleCallClicked = async () => {
        if (!qualityInspection.isClientContactedByCompany()) {
            await qualityInspectionRepository.update(qualityInspectionId, "client_contacted_by_company", {
                quality_inspection: {
                    client_contacted_by_company: true
                }
            });
        }

        callBeneficiaryLink.current.click();
    }

    const handleClientNotReply = async () => {
        if (!qualityInspection.isClientNotReply()) {
            await qualityInspectionRepository.update(qualityInspectionId, "client_not_reply", {
                quality_inspection: {
                    client_not_reply: true
                }
            });
        }

        smsBeneficiaryLink.current.click();
    }

    const getSmsLink = () => {
        let link = `sms:${client.getPhone1()}`;

        if (navigator.userAgent.toLowerCase().includes("chrome")) {
            link += "?";
        } else {
            link += "&";
        }

        link += "body=Bonjour, je viens d'essayer de vous contacter pour la demande d'intervention faite auprès de votre assistance, pourriez vous me recontacter afin de convenir de l'heure de rendez-vous svp ?";

        return link;
    }

    if (isNull(client)) return null;

    return (
        <>
            <Box display="flex" justifyContent="center">
                <Button
                    startIcon={<Call/>}
                    variant="contained"
                    sx={{width: "80%"}}
                    onClick={handleCallClicked}
                    ref={callClientButtonRef}
                    data-test="button-call-beneficiary"
                >
                    Appelez {client.getName()}
                </Button>
                <PopperWrapper
                    elementRef={callClientButtonRef}
                    placement={"top"}
                    content={"Contactez le bénéficiaire pour prendre le rendez-vous"}
                    triggeringEvent={"call-client"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowDownward color={parameter.POPUP_COLOR}/>}
                />
            </Box>
            {
                qualityInspection.isClientContactedByCompany()
                    ? (
                        <Box mt={4} display="flex" justifyContent="center">
                            <Button
                                startIcon={<PhoneMissed/>}
                                variant="contained"
                                color={"error"}
                                sx={{width: "80%"}}
                                onClick={handleClientNotReply}
                                disabled={qualityInspection.isClientNotReply()}
                                data-test="button-beneficiary-not-reply"
                            >
                                Le sociétaire ne répond pas
                            </Button>
                        </Box>
                    )
                    : null
            }

            <Link
                ref={callBeneficiaryLink}
                visibility={"hidden"}
                href={`tel:${client.getPhone1()}`}
                underline={"none"}
                color={"inherit"}
                data-test="link-call-beneficiary"
            />

            <Link
                ref={smsBeneficiaryLink}
                visibility={"hidden"}
                href={getSmsLink()}
                underline={"none"}
                color={"inherit"}
                data-test="link-beneficiary-not-reply"
            />
        </>
    )
}